import { Divider } from '@mui/material'

export const DndDivider = () => (
  <Divider sx={{ borderWidth: 2, borderColor: theme => theme.vars.palette.primary.main }} />
)

export default DndDivider
